import { useState, useEffect } from "react";
import { Menu, X } from "lucide-react";

const links = [
  { id: "tee-booking", label: "Tee Booking" },
  { id: "pro-shop", label: "Pro Shop" },
  { id: "events", label: "Events" },
  { id: "accommodation", label: "Accommodation" },
  { id: "partner", label: "Partner With Us" },
  { id: "membership", label: "Memberships" },
];

export default function StickyNav() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const scrollTo = (id) => {
    setOpen(false);
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <nav
      data-testid="sticky-nav"
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-white/95 backdrop-blur-md border-b border-[#CBA153]/30"
          : "bg-white/70 backdrop-blur-sm border-b border-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 flex items-center justify-between h-16">
        <button
          data-testid="nav-brand"
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          className="font-serif-luxury text-lg md:text-xl text-[#0F4C3A] tracking-[0.18em]"
        >
          THE GOWER GOLF CLUB
        </button>

        <div className="hidden lg:flex items-center gap-9">
          {links.map((l) => (
            <button
              key={l.id}
              data-testid={`nav-link-${l.id}`}
              onClick={() => scrollTo(l.id)}
              className="text-[12px] uppercase tracking-[0.22em] text-[#1A1A1A] hover:text-[#CBA153] transition-colors relative group"
            >
              {l.label}
              <span className="absolute -bottom-1 left-0 w-0 h-px bg-[#CBA153] transition-all duration-300 group-hover:w-full" />
            </button>
          ))}
        </div>

        <button
          data-testid="nav-toggle"
          className="lg:hidden text-[#0F4C3A]"
          onClick={() => setOpen((p) => !p)}
          aria-label="Toggle navigation"
        >
          {open ? <X size={22} strokeWidth={1.5} /> : <Menu size={22} strokeWidth={1.5} />}
        </button>
      </div>

      {open && (
        <div data-testid="nav-mobile-panel" className="lg:hidden bg-white border-t border-[#CBA153]/30">
          <div className="px-6 py-6 flex flex-col gap-5">
            {links.map((l) => (
              <button
                key={l.id}
                data-testid={`nav-link-mobile-${l.id}`}
                onClick={() => scrollTo(l.id)}
                className="text-left text-[12px] uppercase tracking-[0.22em] text-[#1A1A1A] hover:text-[#CBA153]"
              >
                {l.label}
              </button>
            ))}
          </div>
        </div>
      )}
    </nav>
  );
}
